import React, { Suspense } from "react";
import { Switch } from "react-router-dom";
import { LayoutSplashScreen, ContentRoute } from "../../../../_metronic/layout";
import ViewUser from "./selected-user/view-user/ViewUser";
import EditUser from "./selected-user/edit-user/EditUser";
import CreateUser from "./users/create-user/CreateUser";
import { Permissions, PermissionType } from "../../../util/Permissions";
import { AsideMenu } from "../../Common/layout/aside/AsideMenu";
import { Section } from "../../Common/layout/Section";
import { UsersMenu } from "../../Common/layout/aside/aside-menu-lists/UsersMenu";

export default function UserManagementPages() {
  return (
    <>
      <AsideMenu>
        <UsersMenu destination="/users/view" />
      </AsideMenu>
      <Section>
        <Suspense fallback={<LayoutSplashScreen />}>
          <div className="py-4 px-6 h-100">
            <Switch>
              <ContentRoute path="/users/create" permission={Permissions.PROFILE} permissionType="create" component={CreateUser} />
              <ContentRoute path="/users/edit/:userId" permission={Permissions.PROFILE} permissionType={PermissionType.UPDATE} component={EditUser} />
              <ContentRoute path="/users/view/:userId" permission={Permissions.PROFILE} component={ViewUser} />
            </Switch>
          </div>
        </Suspense>
      </Section>
    </>
  );
}
